var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"large-page"},[_c('breadcrumbs'),_c('user-form',{staticClass:"mt-4 mt-md-8 contain-form-width mx-auto",attrs:{"is-loading":_vm.isLoading},on:{"submit":_vm.handleSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }